(function () {
  var PIN_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" focusable="false">' +
    '<path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/>' +
    '</svg>';

  function numOrNull(value) {
    if (value == null || value === '') return null;
    var n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function buildDirectionsUrl(title, address, lat, lng) {
    if (address) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(address);
    }
    if (lat != null && lng != null) {
      return (
        'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(lat + ',' + lng)
      );
    }
    if (title) {
      return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(title);
    }
    return '';
  }

  function usableCoords(lat, lng) {
    return lat != null && lng != null && !(lat === 0 && lng === 0);
  }

  function mapsKey(mapEl) {
    var section = mapEl && mapEl.closest ? mapEl.closest('[data-pic-maps-key]') : null;
    var fromSection = section ? String(section.getAttribute('data-pic-maps-key') || '').trim() : '';
    if (fromSection) return fromSection;
    return typeof window.__WB_GMAPS_KEY === 'string' ? window.__WB_GMAPS_KEY.trim() : '';
  }

  function loadMapsApi(mapEl) {
    if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve();
    if (window.__picMapsPromise) return window.__picMapsPromise;
    window.__picMapsPromise = new Promise(function (resolve, reject) {
      var started = Date.now();
      function ready() {
        return window.google && window.google.maps && window.google.maps.Map;
      }
      function wait() {
        if (ready()) return resolve();
        if (Date.now() - started > 10000) return reject(new Error('maps'));
        window.setTimeout(wait, 50);
      }
      if (!document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) {
        var key = mapsKey(mapEl);
        if (!key) return reject(new Error('key'));
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly';
        script.async = true;
        script.onerror = function () {
          reject(new Error('load'));
        };
        document.head.appendChild(script);
      }
      wait();
    });
    return window.__picMapsPromise;
  }

  /* Center-only embed. A q= place search is what opens Google's place card. */
  function plainMapSrc(lat, lng, zoom) {
    if (!usableCoords(lat, lng)) return '';
    var z = Number(zoom);
    if (!Number.isFinite(z) || z <= 0) z = 15;
    return 'https://www.google.com/maps?ll=' + lat + ',' + lng + '&z=' + z + '&t=m&output=embed';
  }

  function setPlainIframe(mapEl, lat, lng, zoom) {
    var src = plainMapSrc(lat, lng, zoom);
    if (!src || !mapEl) return;
    var frame = mapEl.querySelector('[data-pic-map-frame]') || mapEl;
    var iframe = frame.querySelector('iframe');
    if (!iframe) return;
    if (iframe.getAttribute('src') !== src) iframe.setAttribute('src', src);
  }

  function mountPinnedMap(mapEl, lat, lng, zoom) {
    if (!mapEl || !usableCoords(lat, lng)) return;
    var frame = mapEl.querySelector('[data-pic-map-frame]') || mapEl;
    var token = (mapEl.__picMapToken || 0) + 1;
    mapEl.__picMapToken = token;
    loadMapsApi(mapEl)
      .then(function () {
        if (mapEl.__picMapToken !== token) return;
        var canvas = frame.querySelector('[data-pic-map-canvas]');
        if (!canvas) {
          canvas = document.createElement('div');
          canvas.setAttribute('data-pic-map-canvas', '');
          canvas.className = 'pic-map__canvas';
          frame.appendChild(canvas);
        }
        var z = Number(zoom);
        if (!Number.isFinite(z) || z <= 0) z = 15;
        var center = { lat: lat, lng: lng };
        var map = mapEl.__picMap;
        if (!map) {
          map = new window.google.maps.Map(canvas, {
            center: center,
            zoom: z,
            clickableIcons: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
          });
          mapEl.__picMap = map;
          mapEl.__picMarker = new window.google.maps.Marker({ map: map, position: center });
        } else {
          map.setCenter(center);
          map.setZoom(z);
          if (mapEl.__picMarker) mapEl.__picMarker.setPosition(center);
        }
        frame.classList.add('is-pinned');
      })
      .catch(function () {});
  }

  function applyMapDetail(mapEl, detail, useDefault) {
    if (!mapEl) return;
    var mode = mapEl.getAttribute('data-pic-map-dynamic');
    if (!mode) return;

    var payload = useDefault ? readDefaultDetail(mapEl) : detail || {};
    var address = String(payload.address || '').trim();
    var title = titleWithRegion(
      String(payload.title || '').trim(),
      address,
      payload.region_code || payload.state_code || ''
    );
    var lat = numOrNull(payload.lat);
    var lng = numOrNull(payload.lng);
    var zoom = mapEl.getAttribute('data-pic-map-zoom') || '15';
    var showLabel = mapEl.getAttribute('data-pic-show-label') === '1';
    var frame = mapEl.querySelector('[data-pic-map-frame]') || mapEl;
    if (usableCoords(lat, lng)) {
      setPlainIframe(mapEl, lat, lng, zoom);
      mountPinnedMap(mapEl, lat, lng, zoom);
    }

    if (showLabel) {
      var loc = ensureLocationOverlay(frame, true);
      var directionsUrl = buildDirectionsUrl(title, address, lat, lng);
      updateLocationOverlay(loc, title, address, directionsUrl);
    }
  }

  /** City label + region code (e.g. "Aurora, CO") when address/payload has a state. */
  function titleWithRegion(title, address, regionCode) {
    var t = String(title || '').trim();
    if (!t) return t;
    var code = String(regionCode || '')
      .trim()
      .toUpperCase();
    if (!code || code.length !== 2) {
      var m = String(address || '').match(/,\s*([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\b/);
      code = m ? m[1].toUpperCase() : '';
    }
    if (!code || code.length !== 2) return t;
    if (new RegExp(',\\s*' + code + '\\s*$', 'i').test(t)) return t;
    return t + ', ' + code;
  }

  function ensureLocationOverlay(frame, showLabel) {
    if (!frame || !showLabel) return null;
    var loc = frame.querySelector('[data-pic-map-location]');
    if (loc) return loc;

    loc = document.createElement('a');
    loc.className = 'pic-map__location';
    loc.setAttribute('data-pic-map-location', '');
    loc.target = '_blank';
    loc.rel = 'noopener noreferrer';
    loc.innerHTML =
      '<span class="pic-map__location-pin" aria-hidden="true">' +
      PIN_SVG +
      '</span>' +
      '<span class="pic-map__location-text">' +
      '<span class="pic-map__location-title" data-pic-map-location-title></span>' +
      '<span class="pic-map__location-address" data-pic-map-location-address hidden></span>' +
      '</span>';
    frame.appendChild(loc);
    return loc;
  }

  function updateLocationOverlay(loc, title, address, directionsUrl) {
    if (!loc) return;
    var titleEl = loc.querySelector('[data-pic-map-location-title]');
    var addressEl = loc.querySelector('[data-pic-map-location-address]');
    if (titleEl) titleEl.textContent = title || '';
    if (addressEl) {
      if (address) {
        addressEl.textContent = address;
        addressEl.hidden = false;
      } else {
        addressEl.textContent = '';
        addressEl.hidden = true;
      }
    }
    if (directionsUrl && loc.tagName === 'A') {
      loc.href = directionsUrl;
    }
    loc.hidden = !title && !address;
  }

  function readDefaultDetail(mapEl) {
    return {
      title: mapEl.getAttribute('data-pic-default-title') || '',
      address: mapEl.getAttribute('data-pic-default-address') || '',
      lat: numOrNull(mapEl.getAttribute('data-pic-default-lat')),
      lng: numOrNull(mapEl.getAttribute('data-pic-default-lng')),
    };
  }

  function collectEnabledFacilities(detail) {
    var out = [];
    if (!detail) return out;
    var seen = Object.create(null);
    function push(label) {
      var t = '';
      if (label == null) return;
      if (typeof label === 'string' || typeof label === 'number') t = String(label).trim();
      else if (typeof label === 'object') {
        t = String(label.label || label.name || label.title || label.value || '').trim();
      } else {
        t = String(label).trim();
      }
      if (!t) return;
      var key = t.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(t);
    }
    if (Array.isArray(detail.facilities)) {
      detail.facilities.forEach(push);
    }
    if (Array.isArray(detail.facility_options)) {
      detail.facility_options.forEach(push);
    }
    if (detail.wheelchair_accessible) push('Wheelchair accessible');
    if (detail.accessible_toilets) push('Accessible toilets');
    if (detail.ground_level) push('Ground level');
    if (detail.accessible_parking) push('Accessible parking spot available');
    if (detail.lift_to_all_floors) push('Lift to all floors');
    return out;
  }

  var ICON_YES =
    '<span class="pic-facility__icon pic-facility__icon--yes" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
    '<circle class="pic-ico-bg" cx="12" cy="12" r="11"/>' +
    '<path class="pic-ico-mark" d="M7.2 12.4l3 3.1 6.6-7"/>' +
    '</svg></span>';

  var ICON_NO =
    '<span class="pic-facility__icon pic-facility__icon--no" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
    '<circle class="pic-ico-bg" cx="12" cy="12" r="11"/>' +
    '<path class="pic-ico-mark" d="M8 8l8 8M16 8l-8 8"/>' +
    '</svg></span>';

  function escapeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function readFacilityOptionList(root) {
    var host = root.querySelector('[data-pic-facilities]') || root;
    var raw = host.getAttribute('data-pic-facility-options') || '';
    if (!raw) {
      return [...root.querySelectorAll('[data-pic-facility-label]')]
        .map(function (el) {
          return el.getAttribute('data-pic-facility-label') || '';
        })
        .filter(Boolean);
    }
    return raw
      .split('|')
      .map(function (s) {
        return String(s || '').trim();
      })
      .filter(Boolean);
  }

  /** Base section options + any custom venue options not already listed. */
  function mergeFacilityOptions(baseOptions, enabledLabels) {
    var out = [];
    var seen = Object.create(null);
    function push(label) {
      var t = String(label || '').trim();
      if (!t) return;
      var key = t.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(t);
    }
    (Array.isArray(baseOptions) ? baseOptions : []).forEach(push);
    (Array.isArray(enabledLabels) ? enabledLabels : []).forEach(push);
    return out;
  }

  function applyFacilitiesLayout(host, count) {
    if (!host) return;
    var n = Number(count) || 0;
    var cols = 2;
    var colsMobile = 2;
    var size = 15;
    var icon = 22;
    var gapY = 12;
    var gapX = 28;

    if (n >= 16) {
      cols = 4;
      colsMobile = 2;
      size = 12;
      icon = 17;
      gapY = 8;
      gapX = 12;
    } else if (n >= 12) {
      cols = 4;
      colsMobile = 2;
      size = 12.5;
      icon = 18;
      gapY = 9;
      gapX = 14;
    } else if (n >= 9) {
      cols = 3;
      colsMobile = 2;
      size = 13;
      icon = 18;
      gapY = 10;
      gapX = 16;
    } else if (n >= 7) {
      cols = 3;
      colsMobile = 2;
      size = 13.5;
      icon = 20;
      gapY = 10;
      gapX = 18;
    } else if (n >= 5) {
      cols = 3;
      colsMobile = 2;
      size = 14;
      icon = 20;
      gapY = 11;
      gapX = 20;
    }

    host.style.setProperty('--pic-fac-cols', String(cols));
    host.style.setProperty('--pic-fac-cols-mobile', String(colsMobile));
    host.style.setProperty('--pic-fac-size', size + 'px');
    host.style.setProperty('--pic-fac-icon', icon + 'px');
    host.style.setProperty('--pic-fac-gap-y', gapY + 'px');
    host.style.setProperty('--pic-fac-gap-x', gapX + 'px');
    host.setAttribute('data-pic-fac-count', String(n));
  }

  function renderFacilities(root, enabledLabels) {
    if (!root) return;
    var host = root.querySelector('[data-pic-facilities]') || root;
    var grid = root.querySelector('[data-pic-facilities-grid]');
    var empty = root.querySelector('[data-pic-facilities-empty]');
    if (!grid) return;
    var base = readFacilityOptionList(root);
    var options = mergeFacilityOptions(base, enabledLabels);
    var enabled = Object.create(null);
    (Array.isArray(enabledLabels) ? enabledLabels : []).forEach(function (label) {
      var t = String(label || '').trim().toLowerCase();
      if (t) enabled[t] = true;
    });
    if (!options.length) {
      grid.innerHTML = '';
      applyFacilitiesLayout(host, 0);
      if (empty) empty.hidden = Object.keys(enabled).length > 0;
      return;
    }
    applyFacilitiesLayout(host, options.length);
    grid.innerHTML = options
      .map(function (label) {
        var on = !!enabled[String(label).trim().toLowerCase()];
        return (
          '<div class="pic-facility' +
          (on ? '' : ' pic-facility--off') +
          '" data-pic-facility data-pic-facility-label="' +
          escapeAttr(label) +
          '" data-pic-facility-on="' +
          (on ? '1' : '0') +
          '">' +
          (on ? ICON_YES : ICON_NO) +
          '<span class="pic-facility__label">' +
          escapeHtml(label) +
          '</span></div>'
        );
      })
      .join('');
    if (empty) empty.hidden = true;
  }

  function onVenueSelected(e) {
    var detail = e && e.detail;
    if (!detail) return;
    document.querySelectorAll('[data-pic-map-dynamic]').forEach(function (mapEl) {
      applyMapDetail(mapEl, detail, false);
    });
    var facilities = collectEnabledFacilities(detail);
    document.querySelectorAll('[data-pic-section]').forEach(function (root) {
      renderFacilities(root, facilities);
      if (root.getAttribute('data-pic-hub-venue-tab') === '1') {
        if (typeof root.__picActivateTab === 'function') root.__picActivateTab('location');
      }
    });
  }

  function onVenueReset() {
    document.querySelectorAll('[data-pic-map-dynamic]').forEach(function (mapEl) {
      applyMapDetail(mapEl, null, true);
    });
    document.querySelectorAll('[data-pic-section]').forEach(function (root) {
      renderFacilities(root, []);
      if (root.getAttribute('data-pic-hub-venue-tab') === '1') {
        if (typeof root.__picActivateTab === 'function') root.__picActivateTab('expect');
      }
    });
  }

  document.addEventListener('wbw:venue-selected', onVenueSelected);
  document.addEventListener('wbw:venue-reset', onVenueReset);

  function scrollToBookingWizard() {
    var wizard = document.querySelector('.wbw-root');
    if (!wizard || !wizard.scrollIntoView) return;
    wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initSection(root) {
    if (!root || root.dataset.picInit === '1') return;
    root.dataset.picInit = '1';

    root.querySelectorAll('[data-pic-scroll-wizard]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToBookingWizard();
      });
    });

    var facHost = root.querySelector('[data-pic-facilities]');
    if (facHost) {
      var initialCount =
        facHost.querySelectorAll('[data-pic-facility]').length ||
        readFacilityOptionList(root).length;
      applyFacilitiesLayout(facHost, initialCount);
    }

    var tabs = root.querySelectorAll('[data-pic-tab]');
    var panels = root.querySelectorAll('[data-pic-panel]');
    var select = root.querySelector('[data-pic-tabs-select]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      if (!id) return;
      var hasTab = false;
      tabs.forEach(function (tab) {
        if (tab.getAttribute('data-pic-tab') === id) hasTab = true;
      });
      if (!hasTab) return;
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-pic-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-pic-panel') === id;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
      if (select && select.value !== id) select.value = id;
    }

    root.__picActivateTab = activate;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-pic-tab'));
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        activate(select.value);
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pic-section]').forEach(initSection);
    (scope || document).querySelectorAll('.pic-map[data-pic-map-lat]').forEach(function (mapEl) {
      var lat = numOrNull(mapEl.getAttribute('data-pic-map-lat'));
      var lng = numOrNull(mapEl.getAttribute('data-pic-map-lng'));
      var zoom = mapEl.getAttribute('data-pic-map-zoom') || '15';
      setPlainIframe(mapEl, lat, lng, zoom);
      mountPinnedMap(mapEl, lat, lng, zoom);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
})();
